<div class="popup-panel" draggable=".popup-header">
    <div class="popup-header" >
        <span class="title">{{ view.title | translate }}</span>
        <div class="popup-close" (click)="close()"></div>
    </div>
    <div class="popup-body">
        <ng-template component-loader [view]="view" />
    </div>
</div>
